export const INVALID_MESSAGES = {
  email: "Correo inválido",
  text: "Verifique el dato ingresado",
  number: "Verifique el dato ingresado",
  password: "La contraseña es incorrecta",
};
